<template>
  <PageWrap page-title="Finalidad de los inmuebles">
    <LoadingIndicator v-if="loadingData" />

    <BfTable
      v-else
      :data="finalidades"
      :columns="tableColumns"
      border
      @row-click="tableRowClick"
            cell-class-name="tasaciones-small-cell"

    >
      <span slot="nombre" slot-scope="{row}" class="tasaciones-table-marker">
        {{row.nombre}}
      </span>
    </BfTable>

    <BfButton
      :to="{name: 'finalidadinmueble'}"
      tag="router-link"
      class="mt-5"
    >
      Nueva finalidad
    </BfButton>
  </PageWrap>
</template>

<script>
import PageWrap from '@/components/PageWrap';
import LoadingIndicator from '@/components/LoadingIndicator';
import router from '@/router';
import { propertyFinalityTypeAPI } from '@/api';

export default {
  name: 'PropertyFinalitiesList',

  data() {
    return {
      loadingData: false,
      finalidades: {},
    };
  },

  created() {
    this.loadData();
  },

  methods: {
    async loadData() {
      this.loadingData = true;

      try {
        const { data: { data = [] } } = await propertyFinalityTypeAPI.getAll();
        this.finalidades = data;
      } finally {
        this.loadingData = false;
      }
    },

    tableRowClick({ row, column }) {
      if (column.property === 'nombre') {
        const { id } = row;
        router.push({ name: 'finalidadinmueble', params: { id: `${id}` } });
      }
    },
  },

  computed: {
    tableColumns() {
      return [
        {
          label: 'Clave',
          dataKey: 'clave',
          width: 150,
          sortable: true,
        },
        {
          label: 'Nombre',
          dataKey: 'nombre',
          sortable: true,
        },
      ];
    },
  },

  components: {
    LoadingIndicator,
    PageWrap,
  },
};
</script>
